import { getUid } from "../../auth/AuthManager";
import OnevocaServerError from "../../common/OnevocaServerError";
import getApiInstance from "../../common/api";
import { UserSettings } from "../model/UserSettings";
import UserSettingsResponse from "../model/UserSettingsResponse";

export async function fetchUserSettings(): Promise<UserSettings> {
  try {
    const uid = await getUid();

    const response = await getApiInstance(undefined).get(
      `/user/getUserSettings.php?uid=${uid}`
    );

    const error = response.data.error;
    if (error !== undefined) {
      return Promise.reject(new OnevocaServerError(error));
    }

    const result = response.data.result;
    if (result === undefined) {
      return Promise.reject("No data.");
    }

    const userSettings = UserSettingsResponse.fromJson(result);

    return userSettings;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function patchLearningAutoAdjustTermLevel(
  isOn: boolean
): Promise<void> {
  try {
    const uid = await getUid();
    const parameters = {
      uid: uid,
      learningAutoAdjustLevel: isOn,
    };

    const response = await getApiInstance(undefined).post(
      `/user/updateTermLevelAutoAdjust.php`,
      parameters
    );

    const error = response.data.error;
    if (error !== undefined) {
      return Promise.reject(new OnevocaServerError(error));
    } else {
      return;
    }
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function patchAutoPronunciation(isOn: boolean): Promise<void> {
  try {
    const uid = await getUid();
    const parameters = {
      uid: uid,
      is_on: isOn,
    };

    const response = await getApiInstance(undefined).post(
      `/pronunciation/setAutoPronunciation.php`,
      parameters
    );

    const error = response.data.error;
    if (error !== undefined) {
      return Promise.reject(new OnevocaServerError(error));
    } else {
      return;
    }
  } catch (error) {
    return Promise.reject(error);
  }
}
